<template>
  <div class="row my-2">
    <div class="col-12 col-md-6">
      <input
        class="form-control"
        placeholder="تلفن همراه یکی از اعضای گروه را وارد کنید"
        v-model="searchMobile"
        @keyup.enter="callSeach"
      />
      <div v-if="error" class="alert alert-danger">تلفن همراه را وارد کنید</div>
    </div>
    <div class="col-12 col-md-1 mt-2 mt-md-0">
      <button class="btn btn-primary w-100" @click="callSeach">جستجو</button>
    </div>
  </div>
</template>
<script>
export default {
  emits: {
    search: Function,
  },
  data() {
    return {
      searchMobile: null,
      error: null,
    };
  },
  methods: {
    callSeach() {
      this.error = null;
      if (!this.searchMobile) {
        this.error = "شماره موبایل را وارد کنید";
        return;
      }
      this.$emit("search", this.searchMobile);
    },
  },
};
</script>